import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import type { RecordModificationResponse } from "#root/utility/remote-data";
import type { ReactNode } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { corporateActionCollection, type CorporateActionListItem } from "#root/schema/platform/reference-data";
import PageLayout from "./layout";

export default function ({ corporateActionId }): ReactNode {
  const navigate = useNavigate();

  const handleUpdate = useCallback(
    (data: RecordModificationResponse<CorporateActionListItem>) => {
      if ("deleted" in data) {
        navigate("/admin/platform/reference/corporateAction");
      } else if ("created" in data) {
        navigate(`/admin/platform/reference/corporateAction/${data.created}`);
      }
    },
    [navigate],
  );

  return (
    <PageLayout title="Reference Data Platform - Edit Corporate Action">
      <section>
        <h2>{corporateActionId === "new" ? "Create" : "Edit"} Corporate Action</h2>
        <StandardEditor id={corporateActionId} collection={corporateActionCollection} onSave={handleUpdate} onDelete={handleUpdate}>
          <Fields.Set name="source">
            <label>Event Source</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="symbol">
            <label>Symbol</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="eventType">
            <label>Event Type</label>
            <Fields.Select>
              <Fields.Option value="dividend">Unadjusted Dividend</Fields.Option>
              <Fields.Option value="earnings">Earnings</Fields.Option>
              <Fields.Option value="split">Stock Split</Fields.Option>
              <Fields.Option value="adjustedDividend">Adjusted Dividend</Fields.Option>
              <Fields.Option value="symbolChange">Symbol Change</Fields.Option>
              <Fields.Option value="acquiredUSD">Acquired USD</Fields.Option>
              <Fields.Option value="delisted">Delisted</Fields.Option>
              <Fields.Option value="acquiredWithShares">Acquired With Shares</Fields.Option>
              <Fields.Option value="liquidatedUSD">Liquidated USD</Fields.Option>
              <Fields.Option value="mergerUSD">Merger USD</Fields.Option>
              <Fields.Option value="liquidated">Liquidated</Fields.Option>
              <Fields.Option value="mergerWithShares">Merger With Shares</Fields.Option>
            </Fields.Select>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="eventDate">
            <label>Event Date</label>
            <Fields.DateField required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="value">
            <label>Event Value</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
